import { BaseComponentTranslations } from "../enums";

export const baseComponentTranslations = {
  [BaseComponentTranslations.NumberInput_CalculationType]: "Calculation Type"
};
